import $ from 'jquery';

const switchDigit = (position, number:number) => {
  const digit = position.find('.digit')

  if (digit.is(':animated')) {
    return false;
  }
  if (position.data('digit') === number) {
    // We are already showing this number
    return false;
  }
  position.data('digit', number);
  const replacement = $('<span>', {
    class: 'digit DINPro',
    css: {
      top: '2.5em',
      opacity: 0
    },
    html: number
  });

  // The .static class is added when the animation
  // completes. This makes it run smoother.

  digit
    .before(replacement)
    .removeClass('static')
    .animate({ top: '-2.1em', opacity: 0 }, 'fast', function () {
      digit.remove();
    })

  replacement
    .delay(100)
    .animate({ top: 0, opacity: 1 }, 'fast', function () {
      replacement.addClass('static');
    });
}
export const updateDuo = (minor:number, major:number, value:number, positions) => {
  if ((major - minor) > 1) {
    switchDigit(positions.eq(minor), Math.floor(value / 100) % 10);
    switchDigit(positions.eq(minor + 1), Math.floor(value / 10) % 10);
    switchDigit(positions.eq(major), Math.floor(value % 10));
  } else {
    switchDigit(positions.eq(minor), Math.floor(value / 10) % 10);
    switchDigit(positions.eq(major), Math.floor(value % 10));
  }
}
